import React from 'react';
import { Box, Typography, Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Info } from '@mui/icons-material';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#0C3058',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#0C3058',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #0C3058',
    textAlign: 'center',
    padding: '8px 12px',
  },
}));

const InfoStatCard = ({ title, mainValue, unit, secondaryText, tooltipText }) => (
  <Box sx={{ textAlign: 'left', p: 0, height: '100%' }}>
    <Typography variant="h6" component="h3" sx={{ mb: 1, fontWeight: 400 }}>
      {title}
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: '#0C3058', mr: 1 }}>
        {mainValue} {unit && <Typography component="span" variant="h6">{unit}</Typography>}
      </Typography>
      <CustomTooltip title={tooltipText} placement="top">
        <Info sx={{ fontSize: 20, color: '#0C3058', cursor: 'pointer' }} />
      </CustomTooltip>
    </Box>
    {secondaryText && (
      <Typography variant="body2" color="text.secondary">
        {secondaryText}
      </Typography>
    )}
  </Box>
);

export default InfoStatCard; 